import { ActionBarSubtenantEndpoints } from 'types/models/ActionBarSubtenantEndpoints';
import {AuthUser} from '../../types/models/AuthUser';
import {AuthType} from './AppEnums';

export const authRole = {
  admin: ['admin'],
  user: ['user', 'admin'],
};

export const defaultUser: AuthUser = {
  uid: 'RFedvhji876rfhjuecvh7',
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: authRole.user,
  authType: AuthType.AUTH0,
  photoURL: '/assets/images/avatar/A11.jpg',
  groups: []
};
export const initialUrl = '/tenant-list'; // this url will open after login

// NOTE: Remember to add any new subtenants to the switch-case statement in modules/subtenant/Pages/SubtenantDashboard/index.tsx
export const actionBarConnectorEndpoints: {[key: string]: ActionBarSubtenantEndpoints} =
{
  sitoo: {
    baseUrl: '/sitoo',
    baseUrlDev: '/sitoo',
    nextItems: 'items/next',
    nextOrders: 'orders/next',
    nextPrices: 'prices/next',
    nextWarehouse: 'warehouse/next',
    resendOrder: 'orders/next?retry=',
  },
  shopify: {
    baseUrl: '/shopify/v1',
    baseUrlDev: '/shopify/v1',
    nextItems: 'item',
    nextOrders: 'order',
    nextPrices: 'price',
    nextWarehouse: 'inventory',
    resendOrder: 'order?retry=',
  },
  colect: {
    baseUrl: '/colect/v1',
    baseUrlDev: '/colect/v1',
    nextItems: 'item/next',
    nextOrders: 'order/next',
    nextPrices: 'price/next',
    nextWarehouse: 'warehouse/next',
    nextShipment: 'shipment/next',
    nextCustomer: 'customer/next',
  },
  storm: {
    baseUrl: '/storm/v1',
    baseUrlDev: '/storm/v1',
    nextItems: 'item/next',
    nextPrices: 'price/next',
    nextWarehouse: 'warehouse/next',
  },
  wgr: {
    baseUrl: '/wikinggruppen/v1',
    baseUrlDev: '/wikinggruppen/v1',
    nextItems: 'items/next',
    nextPrices: 'prices/next',
    nextWarehouse: 'stock/next',
    nextOrders: 'orders/next',
    resendOrder: 'orders/next?retry=',
  },
  delogue: {
    baseUrl: '/delogue/v1',
    baseUrlDev: '/delogue/v1',
    nextItems: 'item/next',
  },
  queryservice: {
    baseUrl: '/queryservice/v1',
    baseUrlDev: '/queryservice/v1',
    nextItems: 'item/next',
    nextPrices: 'price/next',
    nextWarehouse: 'warehouse/next',
    nextCustomer: 'customer/next',
  },
  bigcommerce: {
    baseUrl: '/bigcommerce/v1',
    baseUrlDev: '/bigcommerce/v1',
    nextItems: 'item/next',
    nextPrices: 'price/next',
    nextWarehouse: 'warehouse/next',
    nextShipment: 'shipment/next',
    nextOrders: 'order/next',
  },
  centra: {
    baseUrl: '/centra/v1',
    baseUrlDev: '/centra/v1',
    nextItems: 'items/next',
    nextPrices: 'prices/next',
    nextWarehouse: 'warehouse/next',
    nextOrders: 'orders/next',
    nextShipment: 'shipments/next',
    resendOrder: 'orders/next?retry=',
  },
  nuorder: {
    baseUrl: '/nuorder/v1',
    baseUrlDev: '/nuorder/v1',
    nextItems: 'item/next',
    nextPrices: 'price/next',
    nextWarehouse: 'warehouse/next',
    nextShipment: 'shipment/next',
    nextOrders: 'order/next',
    nextCustomer: 'customer/next',
    resendOrder: 'order/next?retry=',
  },
  optimizely: {
    baseUrl: '/optimizely/v1',
    baseUrlDev: '/optimizely/v1',
    nextOrders: 'order',
  },
  jetshop: {
    baseUrl: '/jetshop/v1',
    baseUrlDev: '/jetshop/v1',
    nextItems: 'item/next',
    nextOrders: 'order/next',
  },
  brink: {
    baseUrl: '/brink/v1',
    baseUrlDev: '/brink/v1',
    nextItems: 'items/next',
    nextOrders: 'orders/next',
    nextOrdersPost: 'orders/next',
    nextPrices: 'prices/next',
    nextWarehouse: 'warehouses/next',
    nextShipment: 'shipments/next',
  },
  addimotion: {
    baseUrl: '/addimotion',
    baseUrlDev: '/addimotion',
    nextOrders: 'orders/next',
    nextShipment: 'shipment/next',
  },
  plytix: {
    baseUrl: '/plytix/v1',
    baseUrlDev: '/plytix/v1',
    nextItems: 'item/next',
    nextPrices: 'price/next',
    nextWarehouse: 'warehouse/next',
  },
  litium: {
    baseUrl: '/litium/v1',
    baseUrlDev: '/litium/v1',
    nextItems: 'items/next',
    nextPrices: 'prices/next',
    nextWarehouse: 'warehouses/next',
    nextOrders: 'orders/next',
    nextShipment: 'shipments/next',
    nextCustomer: 'customers/next',
  },
  magento: {
    baseUrl: '/magento/v1',
    baseUrlDev: '/magento/v1',
    nextItems: 'items/next',
    nextPrices: 'prices/next',
    nextWarehouse: 'warehouses/next',
    nextOrders: 'orders/next',
    nextShipment: 'shipments/next',
    nextCustomer: 'customers/next',
  },
  resourced: {
    baseUrl: '/resourced/v1',
    baseUrlDev: '/resourced/v1',
    nextItems: 'items/next',
    nextPrices: 'prices/next',
    nextWarehouse: 'resourced/next',
    nextOrders: 'orders/next',
    nextShipment: 'resourced/next',
    nextCustomer: 'resourced/next',
  },
};